"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITargetArea = void 0;
var ITargetArea;
(function (ITargetArea) {
    ITargetArea["Back"] = "Back";
    ITargetArea["Chest"] = "Chest";
    ITargetArea["Arms"] = "Arms";
    ITargetArea["Shoulders"] = "Shoulders";
    ITargetArea["Glutes"] = "Glutes";
    ITargetArea["Legs"] = "Legs";
    ITargetArea["Core"] = "Core";
    ITargetArea["TotalBody"] = "Total Body";
    ITargetArea["UpperBody"] = "Upper Body";
    ITargetArea["Abs"] = "Abs";
})(ITargetArea || (exports.ITargetArea = ITargetArea = {}));
//# sourceMappingURL=target-area.js.map